
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vlozeni-inzeratu/rozcestnik",
      function () {
        return require("private-next-pages/vlozeni-inzeratu/rozcestnik/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vlozeni-inzeratu/rozcestnik"])
      });
    }
  